import { render, staticRenderFns } from "./ProgramSchoolEdit.vue?vue&type=template&id=08277e79&"
import script from "./ProgramSchoolEdit.vue?vue&type=script&lang=js&"
export * from "./ProgramSchoolEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProgramSchoolEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports